import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parseImageUrl from "@insite/mobius/utilities/parseImageUrl";
import CENHomeArrowRightFirst from "@tCentro/Icons/CENHomeArrowRightFirst";
import CENHomeArrowRightSecond from "@tCentro/Icons/CENHomeArrowRightSecond";
import CENHomeCardCheck from "@tCentro/Icons/CENHomeCardCheck";
import parse from "html-react-parser";
import { connect, ResolveThunks } from "react-redux";

import siteMessage from "@insite/client-framework/SiteMessage";
import setDashboardIsHomepage from "@insite/client-framework/Store/Context/Handlers/SetDashboardIsHomepage";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useContext, useState } from "react";
import { FC } from "react";
import { css } from "styled-components";

interface BenefitsList {
    fields: {
        textarea: string;
    };
}

const enum fields {
    background = "background",
    desktop_image = "desktop_image",
    tablet_image = "tablet_image",
    mobile_image = "mobile_image",
    backgroundColor = "backgroundColor",
    heading = "heading",
    buttonLabelOne = "buttonLabelOne",
    buttonOneLink = "buttonOneLink",
    buttonLabelTwo = "buttonLabelTwo",
    buttonTwoLink = "buttonTwoLink",
    text = "text",
    divisions = "divisions",
    fullWidthButton = "fullWidthButton",
    createAccountButtonLink = "createAccountButtonLink",
    cardHeading = "cardHeading",
    backgroundImage = "backgroundImage",
    buttonOneBackgroundColor = "buttonOneBackgroundColor",
    buttonOneOpacity = "buttonOneOpacity",
    buttonOneColor = "buttonOneColor",
    buttonTwoBackgroundColor = "buttonTwoBackgroundColor",
    buttonTwoOpacity = "buttonTwoOpacity",
    buttonTwoColor = "buttonTwoColor",
    signInCreateNewAccountContainerBgColor = "signInCreateNewAccountContainerBgColor",
    benefitPointsColor = "benefitPointsColor",
    mainHeadingColor = "mainHeadingColor",
    alreadyCustomerTextColor = "alreadyCustomerTextColor",
    cardHeadingColor = "cardHeadingColor",
    createAccountOrLoginButtonBgColor = "createAccountOrLoginButtonBgColor",
    createAccountOrLoginButtonColor = "createAccountOrLoginButtonColor",
    alreadyCustRegText = "alreadyCustRegText",
    createAccountBtnOpacity = "createAccountBtnOpacity",
    createAccountHoverColor = "createAccountHoverColor",
    createAccountHoverBorderColor = "createAccountHoverBorderColor",
}

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context?.session?.isAuthenticated && !state.context?.session?.isGuest,
    dashboardIsHomepage: state.context.session.dashboardIsHomepage ?? undefined,
});
const mapDispatchToProps = {
    setDashboardIsHomepage,
};
interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.desktop_image]: string;
        [fields.tablet_image]: string;
        [fields.mobile_image]: string;
        [fields.heading]: string;
        [fields.buttonLabelOne]: string;
        [fields.buttonOneBackgroundColor]: string;
        [fields.buttonOneColor]: string;
        [fields.buttonLabelTwo]: string;
        [fields.buttonTwoBackgroundColor]: string;
        [fields.buttonTwoColor]: string;
        [fields.text]: string;
        [fields.divisions]: BenefitsList[];
        [fields.fullWidthButton]: string;
        [fields.cardHeading]: string;
        [fields.backgroundImage]: string;
        [fields.backgroundColor]: string;
        [fields.buttonOneLink]: LinkFieldValue;
        [fields.buttonTwoLink]: LinkFieldValue;
        [fields.createAccountButtonLink]: LinkFieldValue;
        [fields.signInCreateNewAccountContainerBgColor]: string;
        [fields.benefitPointsColor]: string;
        [fields.createAccountHoverColor]: string;
        [fields.createAccountHoverBorderColor]: string;
        [fields.mainHeadingColor]: string;
        [fields.alreadyCustomerTextColor]: string;
        [fields.cardHeadingColor]: string;
        [fields.createAccountOrLoginButtonBgColor]: string;
        [fields.createAccountOrLoginButtonColor]: string;
        [fields.alreadyCustRegText]: string;
        [fields.buttonOneOpacity]: string;
        [fields.buttonTwoOpacity]: string;
        [fields.createAccountBtnOpacity]: string;
    };
}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface HomePageBannerNewStyles {
    signInCreateNewAccountContainer?: InjectableCss;
    checkIconStyles?: IconPresentationProps;
    cardSecondPart: InjectableCss;
    mapOuter: InjectableCss;
    mapInner: InjectableCss;
    buttonDiv: InjectableCss;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
}

export const homePageBannerNewStyles: HomePageBannerNewStyles = {
    checkboxGroup: {
        css: css`
            height: 100%;
            flex-direction: unset;
            padding: 0px;
            color: ${getColor("secondary")};
            font-weight: 600px;
            font-size: 14px;
            line-height: 16px;
        `,
    },
    checkbox: {
        css: css`
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                border: 1px solid ${getColor("secondary")};
                background: white;
                color: ${getColor("secondary")};
            }
            span[role="checkbox"] {
                border: 1px solid ${getColor("secondary")};
            }
            span[role="checkbox"]:focus {
                box-shadow: none !important;
            }
        `,
    },
    checkIconStyles: {
        size: 16,
    },

    cardSecondPart: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    mapOuter: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    mapInner: {
        css: css`
            display: flex;
        `,
    },

    buttonDiv: {
        css: css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 8px;
                    `,
                    css`
                        gap: 8px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};
const styles = homePageBannerNewStyles;

const CENMyAccountBanner: FC<Props> = ({ fields, isAuthenticated, setDashboardIsHomepage, dashboardIsHomepage }) => {
    const iconOne = {
        css: css`
            svg {
                > path {
                    fill: ${fields.buttonOneColor} !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        width: 18px;
                        height: auto;
                    `,
                    css`
                        width: 18px;
                        height: auto;
                    `,
                ])}
        `,
    };

    const iconTwo = {
        css: css`
            svg {
                > path {
                    fill: ${fields.buttonTwoColor} !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        width: 18px;
                        height: auto;
                    `,
                    css`
                        width: 18px;
                        height: auto;
                    `,
                ])}
        `,
    };
    const backgroundStyles =
        fields.background === "image"
            ? `background-image: url(${parseImageUrl(fields.desktop_image).url}) !important;
           background-size: cover;
           max-width: 1800px;
           aspect-ratio : 679/180;
           margin:auto;
           background-repeat:no-repeat;
           `
            : `background-color: ${fields.backgroundColor};`;

    const container = {
        css: css`
            ${backgroundStyles};
            width: 100%;
            display: flex;
            padding: 40px 64px 40px 64px;
            align-items: center;
            gap: 24px;
            max-height: 216px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 40px 16px;
                        flex-direction: column;
                        gap: 70px;
                        max-height: 272px;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                        aspect-ratio: 25/24;
                    `,
                    css`
                        padding: 40px 16px;
                        flex-direction: column;
                        gap: 70px;
                        max-height: 272px;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                        aspect-ratio: 25/24;
                    `,
                    css`
                        padding: 40px 80px;
                        gap: 16px;
                        max-height: 100%;
                        min-height: 328px;
                        background-image: url(${parseImageUrl(fields.tablet_image).url}) !important;
                        aspect-ratio: 96/41;
                    `,
                    null,
                    null,
                ])}
        `,
    };
    const signInAccountContainerStyles = `
            background-color: ${fields.signInCreateNewAccountContainerBgColor};
        `;

    const signInCreateNewAccountContainer = {
        css: css`
            ${signInAccountContainerStyles};
            width: 26%;
            display: flex;
            border-radius: 16px;
            background-color: #ffffff;
            padding: 8px 16px 8px 12px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 45%;
                        padding: 12px;
                        gap: 16px;
                    `,
                    css``,
                    css``,
                ])}
            &:hover {
                background-color: #e0dfe0; /* Replace with your desired hover color */
            }
        `,
    };

    const mainHeading = {
        css: css`
            width: 75%;
            height: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        gap: 24px;
                    `,
                    css`
                        width: 100%;
                        gap: 24px;
                    `,
                    css`
                        width: 70%;
                        gap: 32px;
                    `,
                    css``,
                    css``,
                ])}

            h1 {
                font-family: "Poppins";
                font-weight: 800;
                font-size: 40px;
                line-height: 48px;
                color: ${fields.mainHeadingColor};
                margin-bottom: 0px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-weight: 700;
                            font-size: 32px;
                            line-height: 40px;
                            margin-top: 15px !important;
                        `,
                        css`
                            font-weight: 700;
                            font-size: 32px;
                            line-height: 40px;
                        `,
                        css`
                            font-weight: 700;
                            font-size: 32px;
                            line-height: 40px;
                        `,
                        css``,
                        css``,
                    ])}
            }
        `,
    };

    const buttonOne = {
        css: css`
            background-color: ${fields.buttonOneBackgroundColor};
            color: ${fields.buttonOneColor};
            border: 2px solid ${fields.buttonOneColor};
            border-radius: 24px;
            font-family: "Poppins";
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            padding: 10px 16px 10px 24px;
            gap: 11px;
            display: flex;
            align-items: center;
            min-height: 48px;
            &:hover {
                background-color: ${fields.buttonOneBackgroundColor};
                color: ${fields.buttonOneColor};
                border: 2px solid ${fields.buttonOneColor};
                opacity: ${fields.buttonOneOpacity};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: 32px;
                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                    `,
                    css`
                        min-height: 32px;
                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                    `,
                    css`
                        min-height: 32px;

                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    };
    const buttonTwo = {
        css: css`
            background-color: ${fields.buttonTwoBackgroundColor};
            border: 1px solid ${fields.buttonTwoBackgroundColor} !important;
            color: ${fields.buttonTwoColor};
            border-radius: 24px;
            font-family: "Poppins";
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            padding: 10px 16px 10px 24px;
            gap: 11px;
            display: flex;
            align-items: center;
            min-height: 48px;
            &:hover {
                background-color: ${fields.buttonTwoBackgroundColor} !important;
                color: ${fields.buttonTwoColor};
                opacity: ${fields.buttonTwoOpacity};
                border: 1px solid ${fields.buttonTwoBackgroundColor} !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                        min-height: 32px;
                    `,
                    css`
                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                        min-height: 32px;
                    `,
                    css`
                        border-radius: 16px;
                        padding: 8px 12px 8px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 16px;
                        min-height: 32px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    };

    const { isInShell } = useShellContext();
    const history = useHistory();

    const { url: buttonOneUrl, title: buttonOneTitle } = useGetLink(fields.buttonOneLink);
    const onClickButtonOne = () => {
        if (!buttonOneUrl) {
            return;
        }

        if (buttonOneUrl.startsWith("http")) {
            if (isInShell) {
                return;
            }
            window.location.href = buttonOneUrl;
        } else {
            history.push(buttonOneUrl);
        }
    };

    const { url: buttonTwoUrl, title: buttonTwoTitle } = useGetLink(fields.buttonTwoLink);
    const onClickButtonTwo = () => {
        if (!buttonTwoUrl) {
            return;
        }

        if (buttonTwoUrl.startsWith("http")) {
            if (isInShell) {
                return;
            }
            window.location.href = buttonTwoUrl;
        } else {
            history.push(buttonTwoUrl);
        }
    };

    const { url: createAccountUrl, title: createAccountTitle } = useGetLink(fields.createAccountButtonLink);

    const toasterContext = useContext(ToasterContext);
    const [isCheckboxSelected, setIsCheckboxSelected] = useState(dashboardIsHomepage);
    const dashboardIsHomepageChange = (event: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setIsCheckboxSelected(value);
        setDashboardIsHomepage({ dashboardIsHomepage: value });
        if (value) {
            toasterContext.addToast({
                body: (
                    <>
                        {translate("Dashboard set as your homepage. To change, visit your ")}
                        <a href="/MyAccount/AccountSettings" style={{ color: "#007bff" }}>
                            {translate("Account Settings")}
                        </a>
                        .
                    </>
                ),
                messageType: "success",
            });
        }
    };

    return (
        <StyledWrapper {...container}>
            <StyledWrapper {...mainHeading}>
                <Typography variant="h1">{fields.heading}</Typography>
                <StyledWrapper {...styles.buttonDiv}>
                    <Button {...buttonOne} onClick={onClickButtonOne}>
                        {fields.buttonLabelOne} <Icon src={CENHomeArrowRightFirst} {...iconOne} />
                    </Button>

                    <Button {...buttonTwo} onClick={onClickButtonTwo}>
                        {fields.buttonLabelTwo} <Icon src={CENHomeArrowRightSecond} {...iconTwo} />
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
            {!isCheckboxSelected && (
                <StyledWrapper {...signInCreateNewAccountContainer} data-test-selector="rightPart">
                    <CheckboxGroup {...styles.checkboxGroup}>
                        <Checkbox
                            {...styles.checkbox}
                            onChange={dashboardIsHomepageChange}
                            checked={isCheckboxSelected}
                            data-test-selector="makeMyHomePageCheckbox"
                        >
                            {siteMessage("Dashboard_MakeMyHomepage")}
                        </Checkbox>
                    </CheckboxGroup>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CENMyAccountBanner),
    definition: {
        group: "Common",
        displayName: "CENMyAccountBanner",
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
            },
            {
                fieldType: "Contextual",
                name: fields.desktop_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Desktop_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.tablet_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Tablet_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.mobile_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Mobile_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
            },
            {
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Heading",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.mainHeadingColor,
                editorTemplate: "ColorPickerField",
                displayName: "Main Heading Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.buttonLabelOne,
                editorTemplate: "TextField",
                displayName: "Button Label One",
                defaultValue: "",
                fieldType: "General",
            },
            {
                fieldType: "Contextual",
                name: fields.buttonOneLink,
                displayName: "Button One Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.buttonOneBackgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button One Background Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.buttonOneOpacity,
                editorTemplate: "TextField",
                displayName: "Button One Opacity",
                defaultValue: "0.7",
                fieldType: "General",
            },
            {
                name: fields.buttonOneColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button One Color",
                defaultValue: "#8f0446",
                fieldType: "General",
            },
            {
                name: fields.buttonLabelTwo,
                editorTemplate: "TextField",
                displayName: "Button Label Two",
                defaultValue: "",
                fieldType: "General",
            },
            {
                fieldType: "Contextual",
                name: fields.buttonTwoLink,
                displayName: "Button Two Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.buttonTwoBackgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button Two Background Color",
                defaultValue: "#8f0446",
                fieldType: "General",
            },
            {
                name: fields.buttonTwoOpacity,
                editorTemplate: "TextField",
                displayName: "Button Two Opacity",
                defaultValue: "0.7",
                fieldType: "General",
            },
            {
                name: fields.buttonTwoColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button Two Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.signInCreateNewAccountContainerBgColor,
                editorTemplate: "ColorPickerField",
                displayName: "signInCreateNewAccountContainer Background Color",
                defaultValue: "#eef3f0",
                fieldType: "General",
            },
            {
                name: fields.text,
                editorTemplate: "TextField",
                displayName: "Card Heading",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.cardHeadingColor,
                editorTemplate: "ColorPickerField",
                displayName: "Card Heading Color",
                defaultValue: "#262525",
                fieldType: "General",
            },
            {
                name: fields.benefitPointsColor,
                editorTemplate: "ColorPickerField",
                displayName: "Benfits Text Color",
                defaultValue: `${getColor("primary")}`,
                fieldType: "General",
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.textarea;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "textarea",
                        editorTemplate: "MultilineTextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.fullWidthButton,
                editorTemplate: "RichTextField",
                displayName: "Create Account Button Label",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.createAccountHoverColor,
                editorTemplate: "ColorPickerField",
                displayName: " Create Account Hover Color",
                defaultValue: "#262525",
                fieldType: "General",
            },
            {
                name: fields.createAccountHoverBorderColor,
                editorTemplate: "ColorPickerField",
                displayName: " Create Account Hover Border Color",
                defaultValue: "#262525",
                fieldType: "General",
            },
            {
                name: fields.createAccountOrLoginButtonBgColor,
                editorTemplate: "ColorPickerField",
                displayName: "Create Account Or Login Button Bg Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.createAccountBtnOpacity,
                editorTemplate: "TextField",
                displayName: "Button  Opacity",
                defaultValue: "0.7",
                fieldType: "General",
            },
            {
                name: fields.createAccountOrLoginButtonColor,
                editorTemplate: "ColorPickerField",
                displayName: "Create Account Or Login Button Color",
                defaultValue: "#636161",
                fieldType: "General",
            },

            {
                fieldType: "Contextual",
                name: fields.createAccountButtonLink,
                displayName: "Create Account Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.alreadyCustRegText,
                editorTemplate: "RichTextField",
                displayName: "Already Cust Register Text",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.alreadyCustomerTextColor,
                editorTemplate: "ColorPickerField",
                displayName: "Already customer Text color",
                defaultValue: "#262525",
                fieldType: "General",
            },
        ],
    },
};
export default widgetModule;
